import { Header } from "@/types/VDataTable";
export const headers: Header[] = [
  {
    text: "Id",
    type: "string",
    align: "left",
    value: "id",
    sortable: true,
    class: "id",
    width: "80px",
  },
  {
    text: "Vessel Name & IMO",
    type: "string",
    align: "left",
    value: "vesselName",
    class: "veselName",
    sortable: true,
  },
  {
    text: "Last Data Sent",
    type: "string",
    align: "left",
    value: "lastDataSent",
    sortable: true,
    class: "lastDataSent",
    width: "200px",
  },
  {
    text: "Created",
    type: "string",
    align: "left",
    value: "created",
    sortable: true,
    class: "created",
    width: "200px",
  },
  {
    text: "Assign to company",
    type: "action-select",
    align: "left",
    value: "assignToCompany",
    sortable: false,
    class: "assignToCompany",
    width: "220px",
  },
  {
    text: "Actions",
    type: "actions",
    align: "left",
    value: "actions",
    sortable: false,
    class: "actions",
    width: "220px",
  },
];
